import { render, staticRenderFns } from "./UserHandle.vue?vue&type=template&id=68ca438e&"
import script from "./UserHandle.vue?vue&type=script&lang=js&"
export * from "./UserHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports